// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MjAsIC0xNTA4KSI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzAwLCAxNDU3KSI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCwgMzMpIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMCwgMTQpIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLCA0KSI+PGc+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjE0IiBoZWlnaHQ9IjE0IiByeD0iMiI+PC9yZWN0PjxwYXRoIGQ9Ik0zLjgsNi42NzU4MzM2MSBMNi40MDQ4NDQ4Myw5LjU5ODI4MjQgTDEwLjcyNzk1MTcsNC4yIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjwvcGF0aD48L2c+PC9nPjwvZz48L2c+PC9nPjwvZz48L2c+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggleButton {
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    font-weight: 400;
    text-rendering: geometricPrecision;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    position: relative;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding-left: 45px;
    line-height: 20px;
    padding-bottom: 5px;
    padding-top: 5px
}

.toggleButton::before {
    background: #d0d2cf;
    border-radius: 20px;
    content: '';
    display: block;
    height: 22px;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transition: all .2s ease;
    width: 37px;
    left: 0
}

.toggleButton::after {
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    opacity: 1;
    background: #fff;
    border-radius: 25px;
    content: '';
    display: block;
    height: 20px;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transition: all .2s ease;
    width: 20px;
    left: 1px
}

.toggleButton.is-error {
    color: #fa5e5c
}

.toggleButton.is-pressed::after {
    width: 25px
}

.toggleButton.is-disabled,.is-disabled .toggleButton {
    color: #d0d2cf
}

.toggleButton.is-disabled::before,.is-disabled .toggleButton::before {
    background: #d0d2cf;
    border-color: #d0d2cf
}

.toggleButton.is-checked::before {
    background: rgba(55, 112, 56, .8);
    border-color: rgba(55, 112, 56, .8)
}

.toggleButton.is-checked::after {
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    opacity: 1;
    left: 16px
}

.toggleButton.is-checked.is-pressed::after {
    left: 11px
}

.toggleButton.is-checked.is-disabled::before,.is-disabled .toggleButton.is-checked::before {
    background: #d0d2cf;
    border-color: #d0d2cf
}

.toggleButton.is-checked.is-disabled::after,.is-disabled .toggleButton.is-checked::after {
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    opacity: 1
}

@media screen and (min-width: 569px) {
    .toggleButton.checkbox {
        padding-left:30px;
        padding-right: 10px;
        position: relative
    }

    .toggleButton.checkbox::before {
        background: #fff;
        border: 1px solid top(#d0d2cf);
        border-radius: 2px;
        box-sizing: border-box;
        content: '';
        display: block;
        height: 14px;
        left: 0;
        position: absolute;
        top: 8px;
        -webkit-transform: translateY(0);
        transform: translateY(0);
        -ms-transform: translateY(0);
        transition: all .2s ease;
        width: 14px
    }

    .toggleButton.checkbox::after {
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
        opacity: 0;
        background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        content: '';
        display: block;
        height: 14px;
        left: 0;
        position: absolute;
        top: 30px;
        -webkit-transform: translateY(0);
        transform: translateY(0);
        -ms-transform: translateY(0);
        transition: all .2s ease;
        width: 14px
    }

    .toggleButton.checkbox:hover.is-disabled::before,.is-disabled .toggleButton.checkbox:hover::before {
        border-color: top(#d0d2cf)
    }

    .toggleButton.checkbox.is-pressed::after {
        left: 0;
        width: 14px
    }

    .toggleButton.checkbox.is-checked::before {
        background: rgba(55, 112, 56, .8);
        border-color: rgba(55, 112, 56, .8)
    }

    .toggleButton.checkbox.is-checked::after {
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
        opacity: 1;
        top: 8px
    }

    .toggleButton.checkbox.is-checked.is-disabled::after {
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
        opacity: 1;
        top: 8px
    }

    .toggleButton.checkbox.dynamic-styling:before {
        opacity: 1
    }

    .toggleButton.checkbox.dynamic-styling:after {
        opacity: 0
    }

    .toggleButton.checkbox.dynamic-styling:hover::before {
        border-color: top(#d0d2cf)
    }

    .toggleButton.checkbox.dynamic-styling .toggleButton__bullet {
        -webkit-transition: all .2s ease;
        background: #fff;
        border: 1px solid top(#d0d2cf);
        border-radius: 2px;
        box-sizing: border-box;
        content: '';
        display: block;
        height: 14px;
        left: 0;
        position: absolute;
        top: 8px;
        -webkit-transform: translateY(0);
        transform: translateY(0);
        -ms-transform: translateY(0);
        transition: all .2s ease;
        width: 14px
    }

 
}`, "",{"version":3,"sources":["webpack://./js/lib/components/Button/ToggleButton/style.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,mCAAmC;IACnC,2BAA2B;IAC3B,+BAA+B;IAC/B,wBAAwB;IACxB,WAAW;IACX;AACJ;;AAEA;IACI,kEAAkE;IAClE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,mCAAmC;IACnC,2BAA2B;IAC3B,+BAA+B;IAC/B,wBAAwB;IACxB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,kEAAkE;IAClE,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,kEAAkE;IAClE;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB;IACJ;;IAEA;QACI,gBAAgB;QAChB,8BAA8B;QAC9B,kBAAkB;QAClB,sBAAsB;QACtB,WAAW;QACX,cAAc;QACd,YAAY;QACZ,OAAO;QACP,kBAAkB;QAClB,QAAQ;QACR,gCAAgC;QAChC,wBAAwB;QACxB,4BAA4B;QAC5B,wBAAwB;QACxB;IACJ;;IAEA;QACI,gEAAgE;QAChE,UAAU;QACV,mDAA2wB;QAC3wB,WAAW;QACX,cAAc;QACd,YAAY;QACZ,OAAO;QACP,kBAAkB;QAClB,SAAS;QACT,gCAAgC;QAChC,wBAAwB;QACxB,4BAA4B;QAC5B,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,OAAO;QACP;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI,kEAAkE;QAClE,UAAU;QACV;IACJ;;IAEA;QACI,kEAAkE;QAClE,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC,gBAAgB;QAChB,8BAA8B;QAC9B,kBAAkB;QAClB,sBAAsB;QACtB,WAAW;QACX,cAAc;QACd,YAAY;QACZ,OAAO;QACP,kBAAkB;QAClB,QAAQ;QACR,gCAAgC;QAChC,wBAAwB;QACxB,4BAA4B;QAC5B,wBAAwB;QACxB;IACJ;;;AAGJ","sourcesContent":[".toggleButton {\n    -webkit-font-smoothing: antialiased;\n    font-size: 14px;\n    font-weight: 400;\n    text-rendering: geometricPrecision;\n    -webkit-tap-highlight-color: transparent;\n    cursor: pointer;\n    position: relative;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    padding-left: 45px;\n    line-height: 20px;\n    padding-bottom: 5px;\n    padding-top: 5px\n}\n\n.toggleButton::before {\n    background: #d0d2cf;\n    border-radius: 20px;\n    content: '';\n    display: block;\n    height: 22px;\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transition: all .2s ease;\n    width: 37px;\n    left: 0\n}\n\n.toggleButton::after {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    opacity: 1;\n    background: #fff;\n    border-radius: 25px;\n    content: '';\n    display: block;\n    height: 20px;\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transition: all .2s ease;\n    width: 20px;\n    left: 1px\n}\n\n.toggleButton.is-error {\n    color: #fa5e5c\n}\n\n.toggleButton.is-pressed::after {\n    width: 25px\n}\n\n.toggleButton.is-disabled,.is-disabled .toggleButton {\n    color: #d0d2cf\n}\n\n.toggleButton.is-disabled::before,.is-disabled .toggleButton::before {\n    background: #d0d2cf;\n    border-color: #d0d2cf\n}\n\n.toggleButton.is-checked::before {\n    background: rgba(55, 112, 56, .8);\n    border-color: rgba(55, 112, 56, .8)\n}\n\n.toggleButton.is-checked::after {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    opacity: 1;\n    left: 16px\n}\n\n.toggleButton.is-checked.is-pressed::after {\n    left: 11px\n}\n\n.toggleButton.is-checked.is-disabled::before,.is-disabled .toggleButton.is-checked::before {\n    background: #d0d2cf;\n    border-color: #d0d2cf\n}\n\n.toggleButton.is-checked.is-disabled::after,.is-disabled .toggleButton.is-checked::after {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    opacity: 1\n}\n\n@media screen and (min-width: 569px) {\n    .toggleButton.checkbox {\n        padding-left:30px;\n        padding-right: 10px;\n        position: relative\n    }\n\n    .toggleButton.checkbox::before {\n        background: #fff;\n        border: 1px solid top(#d0d2cf);\n        border-radius: 2px;\n        box-sizing: border-box;\n        content: '';\n        display: block;\n        height: 14px;\n        left: 0;\n        position: absolute;\n        top: 8px;\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n        -ms-transform: translateY(0);\n        transition: all .2s ease;\n        width: 14px\n    }\n\n    .toggleButton.checkbox::after {\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n        opacity: 0;\n        background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MjAsIC0xNTA4KSI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzAwLCAxNDU3KSI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCwgMzMpIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMCwgMTQpIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLCA0KSI+PGc+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjE0IiBoZWlnaHQ9IjE0IiByeD0iMiI+PC9yZWN0PjxwYXRoIGQ9Ik0zLjgsNi42NzU4MzM2MSBMNi40MDQ4NDQ4Myw5LjU5ODI4MjQgTDEwLjcyNzk1MTcsNC4yIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjwvcGF0aD48L2c+PC9nPjwvZz48L2c+PC9nPjwvZz48L2c+PC9zdmc+);\n        content: '';\n        display: block;\n        height: 14px;\n        left: 0;\n        position: absolute;\n        top: 30px;\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n        -ms-transform: translateY(0);\n        transition: all .2s ease;\n        width: 14px\n    }\n\n    .toggleButton.checkbox:hover.is-disabled::before,.is-disabled .toggleButton.checkbox:hover::before {\n        border-color: top(#d0d2cf)\n    }\n\n    .toggleButton.checkbox.is-pressed::after {\n        left: 0;\n        width: 14px\n    }\n\n    .toggleButton.checkbox.is-checked::before {\n        background: rgba(55, 112, 56, .8);\n        border-color: rgba(55, 112, 56, .8)\n    }\n\n    .toggleButton.checkbox.is-checked::after {\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n        opacity: 1;\n        top: 8px\n    }\n\n    .toggleButton.checkbox.is-checked.is-disabled::after {\n        -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n        opacity: 1;\n        top: 8px\n    }\n\n    .toggleButton.checkbox.dynamic-styling:before {\n        opacity: 1\n    }\n\n    .toggleButton.checkbox.dynamic-styling:after {\n        opacity: 0\n    }\n\n    .toggleButton.checkbox.dynamic-styling:hover::before {\n        border-color: top(#d0d2cf)\n    }\n\n    .toggleButton.checkbox.dynamic-styling .toggleButton__bullet {\n        -webkit-transition: all .2s ease;\n        background: #fff;\n        border: 1px solid top(#d0d2cf);\n        border-radius: 2px;\n        box-sizing: border-box;\n        content: '';\n        display: block;\n        height: 14px;\n        left: 0;\n        position: absolute;\n        top: 8px;\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n        -ms-transform: translateY(0);\n        transition: all .2s ease;\n        width: 14px\n    }\n\n \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
